/** Identifies a mule driver without changing the unit number used by actions. */
export default function MuleBadge({ isMule }: { isMule?: boolean }) {
  if (!isMule) return null;
  return (
    <span className="ml-1 inline-flex shrink-0 items-center rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-amber-900 dark:bg-amber-900 dark:text-amber-100">
      Mule
    </span>
  );
}
